import Vue from 'vue';
import VueGapi from 'vue-gapi';
import ResourcesApp from '../../components/ResourcesApp.vue';

export const initialize = () => {
    const {newsletter, learning_centre} = window.atfVars.featureFlags;

    if (!newsletter && !learning_centre) return;

    Vue.use(VueGapi, {
        // eslint-disable-next-line
        apiKey: atfVars.youtubeApiKey,
    });

    new Vue({
        template: '<ResourcesApp />',
        components: {ResourcesApp},
        el: '#app',
    });
}
export default {
    initialize,
}



// WEBPACK FOOTER //
// ./scripts/modules/resources-app/index.js